import { render, staticRenderFns } from "./DuplicationLog.vue?vue&type=template&id=d23c7dc0&scoped=true"
import script from "./DuplicationLog.vue?vue&type=script&lang=ts"
export * from "./DuplicationLog.vue?vue&type=script&lang=ts"
import style0 from "./DuplicationLog.vue?vue&type=style&index=0&id=d23c7dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23c7dc0",
  null
  
)

export default component.exports